import clsx from "clsx"
import { useTranslation } from "react-i18next"
import { Member } from "src/patents/patents"
import { scoreBackground, useFamilyScores, useMemberScores } from "src/valuations/scores"

export function FamilyRibbons({family}) {
    const {familyScore} = useFamilyScores(family.patentFamilyId)

    return <ScoreRibbon score={familyScore} />
}

export function ExpiryRibbon({member, short = false}: {member: Member, short?: boolean}) {
    const {t} = useTranslation()
    return member.expiryDate 
        ? <div className="text-xs ribbon rounded-sm w-fit">{!short && <span className="text-slate-500">{t('expires')}:</span>} {member.expiryDate}</div> 
        : null
}


export function MemberRibbons({member, short = false}) {
    const score = useMemberScores(member.familyMemberId)

    return <ScoreRibbon {...{score, short}} />
}

export function ScoreRibbon({score, short = false}) {
    const {t} = useTranslation()
    return score
        ? <div className={clsx(scoreBackground(score), 'px-2 py-1 w-fit rounded-sm text-xs whitespace-nowrap text-gray-900/80')}>{!short && (t('score') + ':')} {score}</div>
        : null
}